
export const GET_ERRORS = 'GET_ERRORS';
export const GET_ERRORS2 = 'GET_ERRORS';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const GET_PROFILE = 'GET_PROFILE';
export const PROFILE_LOADING = 'PROFILE_LOADING';
export const PROFILE_NOT_FOUND = 'PROFILE_NOT_FOUND';
export const CLEAR_CURRENT_PROFILE = 'CLEAR_CURRENT_PROFILE';
export const GET_PROFILES = 'GET_PROFILES';
export const POST_LOADING = 'POST_LOADING';
export const LOGIN_AUTH = 'LOGIN_AUTH';
export const TOGLLE_SIDEBAR='TOGLLE_SIDEBAR';
export const SETTING_TOGLE_SIDEBAR='SETTING_TOGLE_SIDEBAR';
export const MANAGEMENT_TOGLE_SIDEBAR='MANAGEMENT_TOGLE_SIDEBAR';
export const REWARD_TOGLE_SIDEBAR='REWARD_TOGLE_SIDEBAR';
export const GET_PGM_LIST = 'GET_PGM_LIST';
export const GET_RETAILER_LIST = 'GET_RETAILER_LIST';
export const GET_REWARD = 'GET_REWARD';
export const GET_REWARD_REDEEM_LIST = 'GET_REWARD_REDEEM_LIST';
export const GET_REWARD_REDEEM_DETAIL = 'GET_REWARD_REDEEM_DETAIL';
export const POST_CREATE_REWARD = 'POST_CREATE_REWARD';
export const POST_CREATE_REWARD_REDEEM = 'POST_CREATE_REWARD_REDEEM';
export const POST_EDIT_REWARD_REDEEM = 'POST_EDIT_REWARD_REDEEM';
export const POSTREWARDS = 'POSTREWARDS';
export const GET_PGM_DETAIL = 'GET_PGM_DETAIL';
export const PUT_ADMIN_VERIFICATION_UPDATE = 'PUT_ADMIN_VERIFICATION_UPDATE';
export const GET_QUERY_LIST = 'GET_QUERY_LIST';
export const GET_QUERY_DETAIL_LIST = 'GET_QUERY_DETAIL_LIST';
export const POST_QUERY_SOLUTION = 'POST_QUERY_SOLUTION';
export const POST_CREATE_FAQ = 'POST_CREATE_FAQ';
export const GET_FAQ_LIST = 'GET_FAQ_LIST';
export const POST_TRAINING_CREATE = 'POST_TRAINING_CREATE';
export const GET_TRAINEE_LIST = 'GET_TRAINEE_LIST';
export const GET_TRAINEE_LIST_ATTENDEE = 'GET_TRAINEE_LIST_ATTENDEE';
export const POST_TRAINEE_INVITE = 'POST_TRAINEE_INVITE';
export const POST_TRAINING_FILTER = 'POST_TRAINING_FILTER';
export const GET_TRAINEE_DETAIL = 'GET_TRAINEE_DETAIL';
export const PUT_TRAINING_UPDATE_DETAILS = 'PUT_TRAINING_UPDATE_DETAILS';
export const POST_DELETE_FAQ_IMG = 'POST_DELETE_FAQ_IMG';
export const POST_CREATE_TRAINER = 'POST_CREATE_TRAINER';
export const GET_TRAINER_DETAIL_LIST = 'GET_TRAINER_DETAIL_LIST';
export const GET_TRAINER_DETAIL = 'GET_TRAINER_DETAIL';
export const POST_UPDATE_TRAINER = "POST_UPDATE_TRAINER";
export const GET_NOTIFICATOIN_DETAIL_LIST = 'GET_NOTIFICATOIN_DETAIL_LIST';
export const GET_NOTIFICATOIN_DETAIL='GET_NOTIFICATOIN_DETAIL';
export const POST_UPDATE_NOTIFICATION = "POST_UPDATE_NOTIFICATION";
export const POST_CREATE_NOTIFICATION = 'POST_CREATE_NOTIFICATION';
export const POST_CREATE_NOTIFICATION_EXCEL = 'POST_CREATE_NOTIFICATION_EXCEL';
export const PGM_CATEGORY ='PGM_CATEGORY';
export const PGM_PAGE ='PGM_PAGE';
export const SEARCH_CRITERIA='SEARCH_CRITERIA';
export const SEARCH_TRAINER='SEARCH_TRAINER';
export const PAGE_TRAINER = 'PAGE_TRAINER';
export const SEARCH_QUERY='SEARCH_QUERY';
export const PAGE_QUERY='PAGE_QUERY';
export const SEARCH_FAQ='SEARCH_FAQ';
export const PAGE_FAQ='PAGE_FAQ';
export const ANNOUNCEMENT_FAQ='ANNOUNCEMENT_FAQ';
export const SEARCH_ANNOUNCMENT='SEARCH_ANNOUNCMENT';
export const SEARCH_TRAINING='SEARCH_TRAINING';
export const PAGE_TRAINING = 'PAGE_TRAINING';
export const SEARCH_NOTIFICATION='SEARCH_NOTIFICATION';
export const PAGE_NOTIFICATION='PAGE_NOTIFICATION';
export const TRAINING_DATA_FILTER='TRAINING_DATA_FILTER';
export const GET_STATE_LIST='STATE_LIST';
export const GET_DISTRICT_LIST='DISTRICT_LIST';
export const POST_DELETE_SKILL = 'POST_DELETE_SKILL';
export const GET_PINCODE_LIST = 'GET_PINCODE_LIST';
export const GET_PINCODE_MASTER_LIST = 'GET_PINCODE_MASTER_LIST';
export const GET_TARGET_ACHIEVEMENT_LIST = 'GET_TARGET_ACHIEVEMENT_LIST';
export const GET_APS_LIST = 'GET_APS_LIST';
export const GET_APS_CUSTOMERS = 'GET_APS_CUSTOMERS';
export const GET_CUSTOMER_TARGET_DETAIL = 'GET_CUSTOMER_TARGET_DETAIL';
export const GET_CUSTOMER_DETAIL_LIST = 'GET_CUSTOMER_DETAIL_LIST';
export const SET_SELECTED_APS = 'SET_SELECTED_APS';
export const CLEAR_SELECTED_APS = 'CLEAR_SELECTED_APS';
export const SET_CUSTOMER_DETAIL_STATE = 'SET_CUSTOMER_DETAIL_STATE';
export const CLEAR_CUSTOMER_DETAIL_STATE = 'CLEAR_CUSTOMER_DETAIL_STATE';
export const POST_CHANGE_PASSWORD = 'POST_CHANGE_PASSWORD';
export const POST_FORGET_PASSWORD = 'POST_FORGET_PASSWORD';
export const POST_RESET_PASSWORD = 'POST_RESET_PASSWORD';
export const SEARCH_DATA_REWARD_REDEEM='SEARCH_DATA_REWARD_REDEEM';
export const PAGE_DATA_REWARD_REDEEM='PAGE_DATA_REWARD_REDEEM';
export const GET_USER_GROUPS='GET_USER_GROUPS';
export const GET_REDEMPTION_LIST = 'GET_REDEMPTION_LIST';
export const GET_SCAN_LIST = 'GET_SCAN_LIST';
export const GET_REFERRAL_POINTS = 'GET_REFERRAL_POINTS';
export const GET_REFERRAL_LIST = 'GET_REFERRAL_LIST';
export const GET_REPORT = 'GET_REPORT';
export const GET_REPORT_NAME='GET_REPORT_NAME';
export const GET_ROLE_NAME='GET_ROLE_NAME';
export const GET_REPORTS_NAME='GET_REPORTS_NAME';
export const PERMISSION_NAME = 'PERMISSION_NAME';
export const GET_ROLE_NAME_LIST='GET_ROLE_NAME_LIST';
export const POST_REDEMPTION = 'POST_REDEMPTION';
export const POST_REFERRAL = 'POST_REFERRAL';
export const POST_SCANLIMIT = 'POST_SCANLIMIT';
export const GET_REDIRECTION_PAGE_LIST='GET_REDIRECTION_PAGE_LIST';
export const GET_RETRIVE_ALL_BANNER_IMAGE='GET_RETRIVE_ALL_BANNER_IMAGE';
export const POST_CREATE_BANNER='POST_CREATE_BANNER';
export const PUT_UPDATE_BANNER='PUT_UPDATE_BANNER';
export const PUT_ACTIVE_BANNER='PUT_ACTIVE_BANNER';
export const PUT_ACTIVE_MSR='PUT_ACTIVE_MSR';
export const DELETE_DELETE_BANNER='DELETE_DELETE_BANNER';
export const GET_BANNER_IMAGE_DETAIL='GET_BANNER_IMAGE_DETAIL';
export const BANNER_LIST_PAGE='BANNER_LIST_PAGE';
export const BANNER_FILTER_DATA='BANNER_FILTER_DATA';
export const UPDATE_BANNER_IMAGE_SEQUENCE='UPDATE_BANNER_IMAGE_SEQUENCE';
export const GET_USER_NAME_LIST='GET_USER_NAME_LIST';
export const GET_MSR_NAME_LIST='GET_MSR_NAME_LIST';
export const GET_PINCODE ='GET_PINCODE';
export const GET_USER_NAME='GET_USER_NAME';
export const GET_MSR_NAME='GET_MSR_NAME';
export const POST_USER_VERIFIED='POST_USER_VERIFIED';
export const PGM_DETAIL_UPDATE = 'PGM_DETAIL_UPDATE';
// Training Module
export const GET_TUTORIAL_LIST = 'GET_TUTORIAL_LIST';
export const GET_VEHICLE_CATEGORY_LIST = 'GET_VEHICLE_CATEGORY_LIST';
export const GET_TUTORIAL_DETAILS = 'GET_TUTORIAL_DETAILS';
export const GET_VEHICLES_LIST = 'GET_VEHICLES_LIST';
export const POST_ADD_MODULE = 'POST_ADD_MODULE';
export const POST_ADD_MODULE_LOADING = 'POST_ADD_MODULE_LOADING';
export const POST_ADD_MODULE_ERROR = 'POST_ADD_MODULE_ERROR';
export const UPDATE_USER_STATUS_SUCCESS = 'UPDATE_USER_STATUS_SUCCESS';
export const GET_MODULE_LIST = 'GET_MODULE_LIST';
export const FETCH_MODULE_BY_ID = 'FETCH_MODULE_BY_ID';
export const POST_EDIT_MODULE = 'POST_EDIT_MODULE';
export const POST_EDIT_MODULE_LOADING = 'POST_EDIT_MODULE_LOADING';
export const POST_EDIT_MODULE_ERROR = 'POST_EDIT_MODULE_ERROR';
export const ADD_QUERY_COMMENT = "ADD_QUERY_COMMENT";
export const GET_QUERY_LIST3W = 'GET_QUERY_LIST3W';
export const GET_QUERY_CATEGORY_LIST = "GET_QUERY_CATEGORY_LIST";
export const GET_ASSIGNEE_LIST = "GET_ASSIGNEE_LIST";
export const ASSIGN_QUERY = "ASSIGN_QUERY";
export const GET_VEHICLES_CONTENT_LIST = "GET_VEHICLES_CONTENT_LIST";
//Referral Section
export const FETCH_REFERRAL_LIST_REQUEST = "FETCH_REFERRAL_LIST_REQUEST";
export const FETCH_REFERRAL_LIST_SUCCESS = "FETCH_REFERRAL_LIST_SUCCESS";
export const FETCH_REFERRAL_LIST_FAILURE = "FETCH_REFERRAL_LIST_FAILURE";
export const GET_CAP_COLOR_CODES_SUCCESS ='GET_CAP_COLOR_CODES_SUCCESS';
export const GET_PART_CATEGORIES_SUCCESS ='GET_PART_CATEGORIES_SUCCESS';
export const RETAILER_SEARCH_CRITERIA = "RETAILER_SEARCH_CRITERIA";

export const GET_UNIQUE_ID_GENERATION_LIST = 'GET_UNIQUE_ID_GENERATION_LIST';
export const SEARCH_UNIQUE_ID_GENERATION_QUERY= 'SEARCH_UNIQUE_ID_GENERATION_QUERY';
export const PAGE_UNIQUE_ID_GENERATION_QUERY= 'PAGE_UNIQUE_ID_GENERATION_QUERY';
export const GET_BEATMAP_LOGS='GET_BEATMAP_LOGS';
export const GET_BEATMAP_LOGS_DETAILS='GET_BEATMAP_LOGS_DETAILS';

// DBT Rules Management
export const GET_DBT_RULES_LIST = 'GET_DBT_RULES_LIST';
export const GET_DBT_RULE_DETAIL = 'GET_DBT_RULE_DETAIL';
export const POST_CREATE_DBT_RULE = 'POST_CREATE_DBT_RULE';
export const PUT_UPDATE_DBT_RULE = 'PUT_UPDATE_DBT_RULE';
export const DELETE_DBT_RULE = 'DELETE_DBT_RULE';

// DBT Configuration (Settings)
export const GET_DBT_CONFIGURATION = 'GET_DBT_CONFIGURATION';
export const POST_DBT_CONFIGURATION = 'POST_DBT_CONFIGURATION';

// USER TYPE LIST
export const GET_USER_TYPE_LIST = 'GET_USER_TYPE_LIST';

// Pincode Master Upload
export const UPLOAD_PINCODE_MASTER = 'UPLOAD_PINCODE_MASTER';
export const GET_PINCODE_UPLOAD_LOGS = 'GET_PINCODE_UPLOAD_LOGS';
export const GET_PINCODE_UPLOAD_LOGS_DETAILS = 'GET_PINCODE_UPLOAD_LOGS_DETAILS';

// DBT Invoice Scan Status
export const GET_DBT_INVOICE_SCAN_STATUS = 'GET_DBT_INVOICE_SCAN_STATUS';

// 2W Training Module
export const GET_TUTORIAL_LIST_2W = 'GET_TUTORIAL_LIST_2W';
export const GET_TUTORIAL_DETAILS_2W = 'GET_TUTORIAL_DETAILS_2W';
export const GET_MODULE_LIST_2W = 'GET_MODULE_LIST_2W';
export const FETCH_MODULE_BY_ID_2W = 'FETCH_MODULE_BY_ID_2W';
export const POST_ADD_MODULE_2W = 'POST_ADD_MODULE_2W';
export const POST_EDIT_MODULE_2W = 'POST_EDIT_MODULE_2W';
export const DELETE_CONTENT_2W = 'DELETE_CONTENT_2W';
export const DELETE_MODULE_2W = 'DELETE_MODULE_2W';
export const GET_TRAINING_CATEGORY_LIST = 'GET_TRAINING_CATEGORY_LIST';
// First Login
export const SET_FIRST_LOGIN = 'SET_FIRST_LOGIN';
export const CLEAR_FIRST_LOGIN = 'CLEAR_FIRST_LOGIN';
